module.exports = __webpack_public_path__ + "static/l-slide03-6df03d377c917e1a901231b3e2752dbb.png";